const state = {
  env: process.env.VUE_APP_ENDPOINTS === 'development' ? 'dev' : 'prd',
  ver: 'v3',
  userStepIndex: 0,
  currentStep: {
    name: 'EyeJack',
    index: 0
  },
  isDialogOpen: false,
  sortSettings: {
    artworks: {
      sortBy: 'dateCreated',
      sortDescending: true
    },
    collections: {
      sortBy: 'dateCreated',
      sortDescending: true
    }
  }
};

const getters = {
  env() {
    return state.env;
  },
  ver() {
    return state.ver;
  },
  currentStep() {
    return state.currentStep;
  },
  userStepIndex() {
    return state.userStepIndex;
  },
  sortSettings() {
    return state.sortSettings;
  },
  isDialogOpen() {
    return state.isDialogOpen;
  }
};

const mutations = {
  setUserStepIndex(state, payload) {
    state.userStepIndex = payload.index;
  },
  setCurrentStep(state, payload) {
    state.currentStep.name = payload.name;
    state.currentStep.index = payload.index;
  },
  setCurrentStepName(state, step) {
    state.currentStep.name = step.name;
  },
  setCurrentStepIndex(state, step) {
    state.currentStep.index = step.index;
  },
  setSortBy(state, payload) {
    state.sortSettings[payload.page].sortBy = payload.sortBy;
  },
  setSortDescending(state, payload) {
    state.sortSettings[payload.page].sortDescending = payload.sortDescending;
  },
  setIsDialogOpen(state, isDialogOpen) {
    state.isDialogOpen = isDialogOpen;
  }
};

export default {
  state,
  getters,
  mutations
};
